import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const connectwisePsa = defineConnector({
  identifier: "connectwisePsa",
  name: "ConnectWise PSA",
  tagLine: "Professional services automation",
  logo,
  protocol: "http",
  tags: ["productivity", "it"],
  defaultUrlPattern: () => "https://[^/]*\\.myconnectwise\\.net/.*",
  auth: (app) =>
    basicAuth({
      username: app.secret.username,
      password: app.secret.password,
    }).withHeaders([
      {
        name: "accept",
        value: `application/vnd.connectwise.com+json; version=${app.config.apiVersion}`,
      },
      {
        name: "clientid",
        value: app.config.clientId,
      },
    ]),
  steps: [
    {
      title: "Find your ConnectWise PSA API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Open the [ConnectWise Manage developer guide](https://developer.connectwise.com/Products/Manage/Developer_Guide#Auth) and create API credentials for an integrator login in ConnectWise PSA. Copy the company ID, public key, private key, and the hostname or subdomain for your instance.",
        },
      ],
    },
    {
      title: "Enter your ConnectWise PSA instance details",
      items: [
        {
          kind: "markdown",
          content: "Enter the details for your ConnectWise PSA instance.",
        },
        {
          kind: "input",
          label: "Hostname",
          placeholder: "api-na.myconnectwise.net",
          required: true,
          target: { kind: "configuration", field: "hostname" },
          helperText:
            "The full ConnectWise PSA hostname. (e.g. https://api-na.myconnectwise.net/v4_6_release/apis/3.0)",
        },
        {
          kind: "input",
          label: "Subdomain",
          placeholder: "my-company",
          required: true,
          target: { kind: "configuration", field: "subdomain" },
        },
        {
          kind: "input",
          label: "API version",
          placeholder: "your-apiVersion",
          required: true,
          target: { kind: "configuration", field: "apiVersion" },
          helperText: "The API version to connect to ConnectWise PSA",
        },
        {
          kind: "input",
          label: "Client ID",
          placeholder: "your-clientId",
          required: true,
          target: { kind: "configuration", field: "clientId" },
          helperText: "The Client ID assigned to your integration",
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Enter the API credentials from your ConnectWise PSA account settings.",
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          target: { kind: "secrets", field: "username" },
          helperText:
            "The ConnectWise PSA CompanyId followed by either the Public Key, Integrator Username, or MemberId",
        },
        {
          kind: "input",
          label: "Password",
          required: true,
          target: { kind: "secrets", field: "password" },
          helperText:
            "Your ConnectWise PSA private key, integrator password, or member hash",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: (configuration) =>
      `https://${configuration.subdomain}.myconnectwise.net/v4_6_release/apis/3.0/`,
  },
  publicEnvVars: ({ subdomain, hostname, apiVersion, clientId }) => ({
    CONNECTWISE_PSA_SUBDOMAIN: subdomain || "",
    CONNECTWISE_PSA_HOSTNAME: hostname || "",
    CONNECTWISE_PSA_API_VERSION: apiVersion || "",
    CONNECTWISE_PSA_CLIENT_ID: clientId || "",
  }),
});
